import axios from 'axios';
import { baseUrl } from './config';
import { ILandAsset } from '../models/LandAsset';

export const getLandAssets = async (landId: string) => {
    const url = `${baseUrl}/land/${landId}/assets`;
    const res = await axios.get(url);
    return res.data.data.items as ILandAsset[];
};
